export const emptyMainUrls = {
  APIManager: '',
  EntityManager: '',
  MainState: '',
  Utils: '',
  UIKit: '',
  Maps: '',
  AuraComponents: '',
  FeatureCore: ''
}
